import { Component, ViewChild } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { FileUpload } from 'primeng/fileupload';
import { ZonesService } from '../../_services/zones.service';
import { ToastMessageOptions, MessageService } from 'primeng/api';
import { firstValueFrom } from 'rxjs';

@Component({
    selector: 'app-zones-upload-excel',
    templateUrl: './zones-upload-excel.component.html',
    styleUrls: ['./zones-upload-excel.component.scss'],
    standalone: false
})
export class ZonesUploadExcelComponent {
  @ViewChild('fileUploader') fileUploader: FileUpload | undefined;

  public file: any;
  public errors: any = [];
  public messagesError: ToastMessageOptions[] = [];

  constructor(
    private config: DynamicDialogConfig,
    private zonesService: ZonesService,
    private dynamicDialogRef: DynamicDialogRef,
    private messageService: MessageService) { }

  ngOnInit(): void {

  }

  async onFileSelect(event: any) {
    //subimos el fichero al file
    this.file = event.currentFiles[0];
    /*let files = event.files;
    for (let file of files) {
      this.files.push(file);      
    }*/
  }

  async importExcel() {
    let response = await firstValueFrom(this.zonesService.uploadExcel(this.config.data.zoneId as string, this.file));
    if (response.length > 0) {
      this.messagesError = response;
      this.file = null;
      this.fileUploader?.clear();
    } else {
      this.messageService.add({ closable: true, severity: 'success', summary: "Éxito", detail: "Fichero importado correctamente." });
      this.dynamicDialogRef.close();
    }
  }

  cancel() {
    this.dynamicDialogRef.close();
  }

  downloadTemplate() {
    window.open("/assets/media/plantilla_zonas.xlsx", "_blank");
  }

}
